import { FC, useContext } from "react";

import appStyles from "../../../App.module.css";
import { AUBusinessTravelContext } from "../../AUBusinessTravel";
import { businessTravelDocs, businessTravelAUDocs } from "../../config/bt-constants";
import { IAUBusinessTravelContext } from "../../config/interfaces";

interface FooterProps {}

const Footer: FC<FooterProps> = (props: FooterProps) => {
  const { version, currentStep } = useContext(AUBusinessTravelContext) as IAUBusinessTravelContext;
  return (
    <div className={`${appStyles.footerContentWrapper} ${appStyles.btFooterContentWrapper}`}>
      {currentStep !== 3 && (
        <div className={appStyles.btFooterLinkWrap}>
          <span>By continuing, you agree to our </span>
          <a
            className={appStyles.btFooterLink}
            href={businessTravelAUDocs.privacyPolicy}
            target="_blank"
            rel="noopener noreferrer"
          >
            Privacy Policy
          </a>
          ,&nbsp;
          <a
            className={appStyles.btFooterLink}
            href={businessTravelAUDocs.termsAndConditions}
            target="_blank"
            rel="noopener noreferrer"
          >
            Terms & Conditions
          </a>
          , and&nbsp;
          <a
            href={businessTravelAUDocs.cookiePolicy}
            className={appStyles.btFooterLink}
            target="_blank"
            rel="noopener noreferrer"
          >
            Cookie Policy.
          </a>
        </div>
      )}
    </div>
  );
};

export default Footer;
